import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FiAnswerOptionsDndEditor } from './fi-answer-options-dnd-editor.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FiContentLanguageSharedModule } from '../fi-content-language-shared/fi-content-language-shared.module';
import { FiAppTextSharedModule } from '../app-text';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { FiErrorMessageModule } from '../fi-error-message';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DragDropModule,
        MatButtonModule,
        MatIconModule,
        FiContentLanguageSharedModule,
        FiAppTextSharedModule,
        MatCheckboxModule,
        MatRadioModule,
        MatInputModule,
        FiErrorMessageModule,
    ],
    declarations: [FiAnswerOptionsDndEditor],
    exports: [FiAnswerOptionsDndEditor],
})
export class FiAnswerOptionsDndEditorModule {}
